import { useCallback } from 'react';
import { AdobeAnalyticsConst } from '../adobeAnalyticsConstants/adobeAnalyticsConstants';
import { useEventTracker } from '../eventTracker/useEventTracker';
import { OnSiteSearchProps } from '../types/AdobeAnalyticsTypes';

export const useOnSiteSearch = () => {
  const buildPayload = useCallback(
    (searchDetails: OnSiteSearchProps) => ({
      timestamp: new Date().toISOString(),
      content: {
        useOnSiteSearch: {
          term: searchDetails.searchVal,
          filter: { type: ['ALL'] },
          searchComponent: searchDetails.searchPos,
        },
      },
    }),
    [],
  );

  const trackEvent = useEventTracker(AdobeAnalyticsConst.EVENTS.ONSITESEARCH, buildPayload);

  return { trackOnSiteSearch: trackEvent };
};
